import {
  ModalBackground,
  ModalContainer,
  Title,
  WrapSides,
  LeftSide,
  RightSide,
  FlexDivLeft,
  FlexDivRight,
  BorderDiv,
  BorderDivIn,
  MakeSideDiv,
  LeftDiv,
  RightDiv,
  Check,
  ModalButton,
  CloseBtn,
  DivColor,
  ButtonDiv
} from "./styles";

import { api } from "../../services/api"
import { useState } from "react"
import { useParams } from "react-router";
import { useEffect} from "react"



const Modal = ({closeModal}) => {
  const [apiRequest, setApiRequest] = useState([])
  const [apiRequest2, setApiRequest2] = useState([])
  const [apiRequest3, setApiRequest3] = useState([])
  const [apiRequest4, setApiRequest4] = useState([])
  const {id} = useParams() 


  useEffect(() => {
      api.get(`bookings/show/${id}`) // LEMBRAR DE MUDAR PRA BOOKINGS ,se quiser testar trocar bookings por clients
      .then((response) => setApiRequest(response.data))
  }, [])
  useEffect(() => {
    api.get(`hotels/show/${id}`) // 
      .then((response) => setApiRequest2(response.data))
  }, [])
  useEffect(() => {
    api.get(`room_types/show/${id}`) // 
      .then((response) => setApiRequest3(response.data))
  }, [])

  useEffect(() => {
    api.get(`packages/show/${id}`) // LEMBRAR DE MUDAR PRA BOOKINGS
    .then((response) => setApiRequest4(response.data))
}, [])


  let Diarias = (apiRequest.end_time- apiRequest.start_time).to_i
  let last_booking = apiRequest4.last_booking // verificar se é a segunda reserva de um pacote
  let used_days = apiRequest4.used_days // dias utilizados na primeira reserva
  let vacation_days = apiRequest4.vacation_days // dias total do pacote
  let dias_perdidos = vacation_days - (used_days + Diarias)
  return (
    
    <DivColor>
    <ModalBackground>
      <ModalContainer>
        <CloseBtn onClick={() => closeModal(false)}>X</CloseBtn>
        <Title>
          Confirme os detalhes da sua solicitação de reserva em Hotel AMERIS
        </Title>
        <WrapSides>
            <LeftSide>
            <h3>Cliente</h3>
            <h4>Nome: {apiRequest.name}</h4>
            <h4>Cpf: {apiRequest.cpf}</h4>
            <h4>Email: {apiRequest.email}</h4>
            <h4>RG: {apiRequest.rg}</h4>
            <h4>Telefone: ({apiRequest.DDD}) {apiRequest.telephone}</h4> 
            <h4>Endereço: {apiRequest.street}, Número {apiRequest.street_number}</h4>
            <h4>Bairro: {apiRequest.neighborhood} </h4>
            <h4>Cidade e estado: {apiRequest.city}, {apiRequest.state}</h4>
            <h4>CEP: {apiRequest.cep}</h4>
            
            <h3>Destino</h3>
            <h4>{apiRequest2.adress}</h4>
            <h3>Hotel</h3>
            <h4>Hotel {apiRequest2.name}</h4>
            <h4>
              {apiRequest2.description}
            </h4>
            <h3>Data de Estadia</h3>
            <h4>{apiRequest.start_time} - {apiRequest.end_time}</h4>
            <h4>{Diarias} diárias</h4>
          </LeftSide>
          <RightSide>
            <FlexDivLeft>
              <h3>Quarto</h3>
              <h4>{apiRequest3.name}</h4>
              <h4>- Acomoda {apiRequest3.capacity} pessoa(s) </h4>
              <h4>- {apiRequest3.description} </h4>
            </FlexDivLeft>

            <FlexDivRight>
              <h3>Número de Hóspedes</h3>
              <h4>{apiRequest.adults} adultos e {apiRequest.children} crianças</h4>
            </FlexDivRight>

            <BorderDiv>
              <BorderDivIn>
                <MakeSideDiv>
                  <LeftDiv>
                    <h1>Minhas Diárias</h1>
                    <h1>Estadia</h1>
                  </LeftDiv>

                  <RightDiv>
                    <h1>{(vacation_days - used_days).to_i} diárias</h1>
                    <h1>{Diarias} diárias</h1> 
                  </RightDiv>
                </MakeSideDiv>
                <hr />
                <MakeSideDiv>
                  <LeftDiv>
                    <h1>Diárias Restantes</h1>
                  </LeftDiv>

                  <RightDiv>
                    <h1 className="gradienteH1">{((vacation_days + dias_perdidos) - Diarias).to_i} diárias</h1>
                  </RightDiv>
                </MakeSideDiv>
                
              </BorderDivIn>
            </BorderDiv>
            { Diarias < 2 ? 
              <h3 className="disabled">As estadias são de no mínimo de 2 (dois) dias</h3>
            :<>
            <Check>
              <label>
                <input type="checkbox" />
                <span>
                  Confirmar os detalhes da solicitação
                  {(last_booking && used_days + Diarias < vacation_days) ? 
                    <span className="lost_days"> e confirmar em perder {dias_perdidos} dia(s)</span>
                  : 
                    <>
                      {(!last_booking  && vacation_days - Diarias === 1) ? <span className="lost_days"> e confirmar em perder 1 dia</span> : null}
                    </>
                  }
                </span>
              </label>
            </Check>
            <ButtonDiv>
              <ModalButton>
                <h1>Solicitar minhas Férias!</h1>
              </ModalButton>
            </ButtonDiv>
            </>}
          </RightSide>
        </WrapSides>
      </ModalContainer>
    </ModalBackground>
    </DivColor>
  );
};

export default Modal;

